export default __webpack_public_path__ + "static/media/star.9cd4dff0.svg";